import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FilterVehicleType } from '@src/app/enum/filters-vehicle.enum';

import { isEqual } from 'lodash';

import { ICheckboxValueFilters, IFilterVehicle, ISubmitFilters } from '@src/app/interfaces/filters-vehicle.interface';
import { OverlayPanel } from 'primeng/overlaypanel';
import { BehaviorSubject, Subscription, debounceTime } from 'rxjs';

@Component({
  selector: 'app-filter-control',
  templateUrl: './filter-control.component.html',
  styleUrls: ['./filter-control.component.scss'],
})
export class FilterControlComponent implements OnInit, OnDestroy {
  public readonly FILTER_VEHICLE_TYPE = FilterVehicleType;

  @Input('selectedControlValue') public set selectedControlValue(data: ISubmitFilters) {
    if (data && !isEqual(data.selectedControlValue, this._selectedControlValue)) {
      this._selectedControlValue = data.selectedControlValue;
    }
  }
  @Input('data') public set setData(data: IFilterVehicle) {
    this._data = data;
    this.setControls();
  };
  @Input() public optionsSelectedCount: number;
  @Input() public isVisibleSearchInput: boolean;

  @Output() public onSubmitFilters$: EventEmitter<ISubmitFilters> = new EventEmitter();

  public _selectedControlValue: any;
  public checkboxValues: ICheckboxValueFilters[] = [];
  public isLoading: boolean;
  public _data: IFilterVehicle;

  public searchInputValue$: BehaviorSubject<string> = new BehaviorSubject(null as any);
  public searchValue: string = '';
  public searchValuePipe: string = '';

  private ComponentSubsc: Subscription = new Subscription();

  constructor() { }

  ngOnInit(): void {
    this.onChangeSearchInputValue();
  }

  ngOnDestroy(): void {
    this.ComponentSubsc.unsubscribe();
  }

  public submit(modal: OverlayPanel): void {
    this.onSubmitFilters$.emit({
      selectedControlValue: this._selectedControlValue,
      checkboxValues: this.checkboxValues.filter(item => item.checkboxValue),
    });
    modal.hide();
  }

  public onShowDropdown(): void {
    document.getElementsByClassName('p-overlaypanel-content').item(0)?.classList.add('overlay-unset-padding');
  }

  public clearFilters(modal: OverlayPanel): void {
    this.clearFiltersValue();
    this.submit(modal);
  }

  public clearFiltersValue(): void {
    this._selectedControlValue = null;
    this.clearCheckboxValues();
  }

  private onChangeSearchInputValue(): void {
    const sub = this.searchInputValue$.pipe(debounceTime(150)).subscribe(
      (data) => {
        this.searchValuePipe = data;
      }
    );
    this.ComponentSubsc.add(sub);
  }

  private setControls(): void {
    if (this._data.type === FilterVehicleType.Group) {
      this.checkboxValues = this._data.options.map(
        (item) => ({
          optionValue: item.value,
          checkboxValue: false, // TODO:
          data: item.data,
        })
      );
    }
  }

  private clearCheckboxValues(): void {
    this.checkboxValues = this.checkboxValues.map(item => ({...item, checkboxValue: false}));
  }

}
